module.exports = __webpack_public_path__ + "assets/fonts/simhei.ab5640f6.ttf";